<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h2>Grup Kampanyası Ekle</h2>

      <v-row style="margin-top: 50px;">
        <v-col cols="12" md="4">
          <h4>Grup Kampanya Başlık</h4>
          <v-text-field
            v-model="campaignGroup.title"
            maxlength="255"
            counter="255"
            :rules="titleRules"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-btn
            depressed
            color="#4d48f9"
            style="text-transform: none !important; float: left; color: white;"
            @click="campaignGroupAdd()"
          >EKLE
          </v-btn>
        </v-col>
      </v-row>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline"
          >Lütfen alanları kontrol edin
          </v-card-title
          >

          <v-card-text>
            <ul>
              <li v-for="errorList in this.errorList" :key="errorList">
                {{ errorList }}
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- <v-row>
          
      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CampaignGroup",
  data: () => ({
    valid: true,
    campaignGroup: {
      title: ""
    },
    errorList: [],
    dialog: false,
    titleRules: [
      (v) => !!v || "Başlık alanı zorunludur.",
      (v) => v.length <= 255 || "Maksimum 255 karakter olmalıdır."
    ]
  }),

  methods: {
    ...mapActions(["addCampaignGroup"]),

    routeCampaignGroupDetail(id) {
      this.$router.push(`/dashboard/groupCampaign/${id}`);
    },

    campaignGroupAdd() {
      if (this.$refs.form.validate()) {

        this.snackbar = true;
        this.addCampaignGroup(this.campaignGroup)
          .then((response) => {
            if (response.processStatus === "Success") {
              this.routeCampaignGroupDetail(response.payload.id);
            } else {
              alert(response.friendlyMessage.message);
            }
          })
          .catch((err) => {
            alert(err);
          });

      } else {
        const errors = [];
        const x = document.getElementsByClassName("v-messages__message");
        for (let i = 0; i < x.length; i++) errors.push(x[i].innerHTML);
        this.errorList = errors;
        this.dialog = true;
      }
    }
  }


};
</script>
